module.exports = __webpack_public_path__ + "img/panch_cuento_3.88551999.png";